export default class ElementMap {
  constructor() {
    this.elements = new WeakMap();
  }

  store(domElement, instance) {
    this.elements.set(domElement, instance);
  }

  remove(domElement) {
    this.elements.delete(domElement);
  }

  getInstance(domElement) {
    return this.elements.get(domElement);
  }
}
